/**
 * Estados possíveis da conexão WebSocket
 */
export type ConnectionState = 'connected' | 'disconnected' | 'reconnecting';

/**
 * Configuração de heartbeat e reconexão
 */
export interface ConnectionConfig {
  /** Intervalo entre pings de heartbeat (ms) */
  heartbeatInterval: number;
  
  /** Timeout para resposta do ping (ms) */
  heartbeatTimeout: number;
  
  /** Número de falhas consecutivas antes de considerar desconectado */
  maxHeartbeatFailures: number;
  
  /** Delay inicial para primeira tentativa de reconexão (ms) */
  reconnectBaseDelay: number;
  
  /** Delay máximo entre tentativas de reconexão (ms) */
  reconnectMaxDelay: number;
  
  /** Multiplicador para backoff exponencial */
  reconnectMultiplier: number;

  /** Habilitar logs de debug */
  enableDebugLogs: boolean;
}

/**
 * Configuração padrão
 */
export const DEFAULT_CONNECTION_CONFIG: ConnectionConfig = {
  heartbeatInterval: 5000, // 5 segundos
  heartbeatTimeout: 3000, // 3 segundos
  maxHeartbeatFailures: 3, // 3 falhas = desconectado
  reconnectBaseDelay: 1000, // 1 segundo
  reconnectMaxDelay: 10000, // 10 segundos
  reconnectMultiplier: 2, // Dobra a cada tentativa
  enableDebugLogs: true,
};

/**
 * Resposta do ping
 */
export interface PongResponse {
  type: 'pong';
  timestamp: number;
}

/**
 * Métricas de conexão
 */
export interface ConnectionMetrics {
  totalReconnections: number;
  totalDisconnections: number;
  currentAttempt: number;
  lastDisconnectTime?: number;
  lastReconnectTime?: number;
  totalDowntime: number; // ms
  averageReconnectTime: number; // ms
}

/**
 * Utilitário para logging condicional com integração Datadog
 */
export class ConnectionLogger {
  constructor(
    private enabled: boolean,
    private datadogService?: any // Opcional para evitar dependência circular
  ) {}

  log(message: string, context?: Record<string, any>): void {
    this.datadogService?.logInfo(message, context);
  }

  warn(message: string, context?: Record<string, any>): void {
    this.datadogService?.logWarn(message, context);
  }

  error(message: string, context?: Record<string, any>): void {
    this.datadogService?.logError(message, context);
  }
}
